import ReactDOM from 'react-dom';
import AdManager from '@buzzfeed/adlib/dist/module/core/base/manager.js';
import {
  config as adsConfig,
  getNumArray,
} from '@buzzfeed/adlib/dist/module/bindings/react';

class CommentsManager extends AdManager {
  constructor({ placeholders, onAdsReady }) {
    super(...arguments);
    this.config.injectMethod = 'inside';
    this.placeholders = placeholders;
    this.placeholders = this.placeholders.filter((el, idx) => (idx + 1) % 5 === 0);

    if (typeof onAdsReady === 'function') {
      this.privateEvents.on('ads-ready', onAdsReady);
    }
  }

  configure() {
    this.placements = [1];
    this.density = 1;

    const portals = Array.prototype.map.call(this.placeholders, element => {
      const AdUnit = this.config.AdUnit;
      let nextAd = this.getNextAd();
      let language = this.language;
      let pixiedust = this.pixiedust;
      return function AdPortal() {
        return ReactDOM.createPortal(
          <AdUnit
            config={nextAd.slot}
            buzzLanguage={language}
            pixiedust={pixiedust}
            className="Ad--comment"
          />,
          element
        );
      };
    });
    this.privateEvents.trigger('ads-ready', portals);
  }
}

export default function createCommentsAdManager({
  AdUnit,
  element,
  onAdsReady,
  pixiedust,
  placeholders,
  language
}) {
  const units = getNumArray(9, 1).map(i => adsConfig[`comment${i}`]);
  const unitsRepeated = [adsConfig['comment-infinite']];

  return new CommentsManager({
    config: {
      AdUnit,
      units,
      unitsRepeated,
    },
    element,
    onAdsReady,
    pixiedust,
    placeholders,
    language
  });
}
